let callbacks = [],
    firstTime = true,
    timeout;
export function debouncedScroll(callback, listenerOptions) {
    callbacks.push(callback);
    if (firstTime) {
        firstTime = false;
        window.addEventListener(
            'scroll',
            () => {
                if (timeout) {
                    window.cancelAnimationFrame(timeout);
                }

                timeout = window.requestAnimationFrame(() =>
                    callbacks.forEach((callback) => callback()),
                );
            },
            listenerOptions,
        );
    }
}

export default class bindScroll {
    constructor(components) {
        this.components = components;
        this.init();
    }

    renderCarousel(wrapper) {
        wrapper.init();
    }

    init() {
        if (this.components.length > 0) {
            if ('IntersectionObserver' in window) {
                let callbacks = new WeakMap();
                let observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            let element = entry.target;
                            let callback = callbacks.get(element);
                            if (callback) {
                                callbacks.delete(element);
                                callback();
                            }
                        }
                    });
                });

                this.components.forEach((component) => {
                    let element =
                        component.wrapper.length > 0 ? component.wrapper.get(0) : component.wrapper;
                    if (typeof element === 'object') {
                        observer.observe(element);
                        callbacks.set(element, component.init);
                    } else {
                        this.checkVisibilityAndRender(true);
                    }
                });
            } else {
                let isBot = /googlebot|bingbot/i.test(navigator.userAgent);
                this.checkVisibilityAndRender(isBot);

                if (!isBot) {
                    debouncedScroll(() => this.checkVisibilityAndRender());
                }
            }
        }
    }

    checkVisibilityAndRender(forceRender) {
        for (let i = 0; i < this.components.length; i++) {
            let component = this.components[i];

            if (forceRender || this.isVisible(true, component.wrapper)) {
                this.renderCarousel(component);
                this.components.splice(i, 1);
                i--;
            }
        }
    }

    isVisible(partial, wrapper) {
        let $t = wrapper,
            $w = $(window),
            viewTop = $w.scrollTop(),
            viewBottom = viewTop + $w.height(),
            _top = $t.offset() != null ? $t.offset().top - 60 : 60,
            _bottom = _top + $t.height(),
            compareTop = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;

        return compareBottom <= viewBottom && compareTop >= viewTop;
    }
}
